<script setup>
import { validationCheck, isInteger } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useServiceItem } from '@store/serviceItem'
const $serviceItem = useServiceItem()

import { useRouter } from 'vue-router'
const router = useRouter()

import Main from './Main.vue'
import BusinessProfileInformation from '../settings/BusinessProfileInformation.vue'
import EditDuration from '@views/service/EditDuration.vue'
import ButtonBack from './ButtonBack.vue'
import ButtonNext from './ButtonNext.vue'
import ButtonSubmit from './ButtonSubmit.vue'

const saveServiceDuration = () => {

    // validation
    let { errors } = validationCheck([
        {
            condition: !isInteger($serviceItem.service.meta.duration),
            message: `${$settings.labels.service?.singular} duration must be an integer number (whole number)`
        },
        {
            condition: $serviceItem.service.meta.duration <= 0,
            message: `${$settings.labels.service?.singular} duration must be greater than 0`
        },
        {
            condition: $serviceItem.service.meta.price_type == 'fixed' && !$serviceItem.service.meta.price,
            message: `${$settings.labels.service?.singular} price is required for Fixed price type`
        },
        {
            condition: $serviceItem.service.meta.price && $serviceItem.service.meta.price <= -1,
            message: `${$settings.labels.service?.singular} price must be equal or greater than 0`
        },
        {
            condition: !$serviceItem.service.meta.price_type,
            message: `${$settings.labels.service?.singular} price type is required`
        }
    ])
    if (errors) return


    $serviceItem.submit('publish', true)
}

const backButton = () => {
    if ($settings.addons.staffs) {
        router.push({ name: 'onboarding.service.staff' })
    } else {
        router.push({ name: 'onboarding.service.general' })
    }
}
</script>

<template>
    <Main title="Set Duration & Price" :progress="100">
        <EditDuration />

        <div class="flex gap-10 mt-5">
            <ButtonBack text="Prev" @click="backButton()" />
            <ButtonSubmit text="Publish" @click="saveServiceDuration()" />
        </div>

        <template #footer>
            <ButtonBack text="Prev" @click="backButton()" />
            <!-- <ButtonNext @click="saveServiceDuration()" /> -->
            <ButtonSubmit text="Publish" @click="saveServiceDuration()" />
        </template>
    </Main>
</template>